<template lang="html">
  <section class="menu">
    <div class="menu__close hover" @click="closeMenu">
      <img src="../assets/close.svg" alt="close" />
    </div>
    <ul class="menu__list">
      <li class="menu__item" @click="closeMenu">
        <router-link to="/works">Work</router-link>
      </li>
      <li class="menu__item" @click="closeMenu">
        <router-link to="/longformat">Long Format</router-link>
      </li>
      <li class="menu__item" @click="closeMenu">
        <router-link to="/aboutus">About Us</router-link>
      </li>
      <li class="menu__item" @click="closeMenu">
        <router-link to="/locations">Locations</router-link>
      </li>
      <!-- <li class="menu__item" @click="closeMenu">
        <router-link to="/productions">Green Productions</router-link>
      </li> -->
      <li class="menu__item" @click="closeMenu">
        <router-link to="/clients">Clients</router-link>
      </li>
      <li class="menu__item" @click="closeMenu">
        <router-link to="/directors">Directors</router-link>
      </li>
      <li class="menu__item" @click="closeMenu">
        <router-link to="/contacts">Contact</router-link>
      </li>
    </ul>
  </section>
</template>

<script>
import anime from "animejs";
export default {
  name: "Menu",
  mounted() {
    anime({
      targets: [".menu__item a"],
      translateY: ["1.1em", 0],
      translateZ: 0,
      duration: 2000,
      easing: "easeInOutCubic",
      delay: function (el, i) {
        return 200 * i + 100;
      }
    });
    anime({
      targets: [".menu__close"],
      opacity: [0, 1],
      duration: 1000,
      easing: "easeInOutCubic",
      delay: 500
    });
  },
  methods: {
    closeMenu() {
      this.$store.commit("toggleMenu", false);
    }
  }
};
</script>

<style lang="scss">
@import "../styles/config.scss";

.menu {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  text-align: center;
  z-index: 5;
  background: rgba(0, 0, 0, 0.6);
  padding-top: 140px;

  &__close {
    position: absolute;
    width: 60px;
    height: 60px;
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
  }

  &__item {
    overflow: hidden;
    margin: 10px 0;

    a {
      font-family: CamptonBold;
      font-size: 68px;
      line-height: 82px;
      letter-spacing: 1px;
      -webkit-text-stroke-width: 1px;
      -webkit-text-stroke-color: var(--Neu01);
      color: transparent;
      display: inline-block;
      transition: color 0.2s ease-out;

      &:hover {
        color: var(--Neu01);
      }
    }
  }

  @include mq(0, 768px) {
    &__close {
      top: 20px;
    }

    &__list {
      width: 100%;
      top: 0;
      left: 0;
      transform: none;
      position: relative;
    }

    &__item {

      a {
        font-size: 36px;
        line-height: 42px;
      }
    }
  }

  @media (max-height: 820px) {
    padding: 0;
    padding-top: 100px;

    &__close {
      top: 20px;
    }

    &__item {

      a {
        font-size: 50px;
        line-height: 58px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue